import jQuery from 'jquery';

const grecaptcha = window.grecaptcha;

jQuery(function ($) {
  const recaptchaPublicKey = $('meta[name=recaptcha_public]').attr('content');

  const $contactForm = $('form.contact-form');

  if ($contactForm.length > 0) {
    const ContactFormValidator = $contactForm.validate({
      debug: true,
      showErrors: function () {
        this.defaultShowErrors();
      },
      messages: {},
      rules: {},
    });

    $contactForm.on('submit', function (e) {
      e.preventDefault();

      const $myForm = $(this);
      const target = $myForm.attr('action');
      const formData = $myForm.serializeArray();
      const $submitButton = $myForm.find('button[type=submit]');
      const submitButtonHtml = $submitButton.html();

      $myForm.find('.alert').fadeOut();

      if (!ContactFormValidator.valid()) {
        // Check if form is valid
        return false;
      }

      $submitButton.attr('disabled', 'disabled').html('<i class="fas fa-circle-notch fa-spin"></i>');

      formData.push({
        name: 'action',
        value: 'sendcontactform',
      });

      $('.alert').fadeOut();

      grecaptcha.execute(recaptchaPublicKey, { action: 'contact' }).then(function (token) {
        formData.push({
          name: 'recaptchaToken',
          value: token,
        });

        $.post(target, formData)
          .always(function () {
            $submitButton.removeAttr('disabled').html(submitButtonHtml);
          })
          .done(function () {
            $submitButton.attr('disabled', 'disabled').html('<i class="fas fa-check"></i>');
            $myForm.fadeOut(function () {
              $myForm.parent().find('.alert-success').fadeIn();
            });
          })
          .fail(function () {
            $myForm.find('.alert.alert-danger').fadeIn();
          });
      });
    });
  }
});
